import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
}
const qsAll = {
  gridSections: 'data-section-type="offers-grid"',
  detailSections: 'data-section-type="offer-details"',
  buttons: 'data-json',
}

const initSection = (section) => {
  const buttons = section.querySelectorAll(`[${qsAll.buttons}]`)
  buttons.forEach(button => {
    button.addEventListener('click', (e) => {
      const jsonData = JSON.parse(e.target.dataset.json)
      const popupHtml = `
        <div class="mb-6 lg:mb-10 text-sm leading-4">Details</div>
        <h2 class="text-[2.5rem] font-bold leading-none mb-6 lg:mb-10 uppercase">${jsonData.title}</h2>
        <div class="text-sm">${jsonData.text}</div>
      `
      window.openPopup(popupHtml)
    })
  })
}

export const setupOffersGrid = () => {
  cacheDom(dom, qs, qsAll)
  dom.gridSections.forEach(section => initSection(section))
  dom.detailSections.forEach(section => initSection(section))
}